import { Button, Flex, Icon, Text, useTheme } from "@repo/ui";
import { useStyles } from "purse-styles";
import { useLocation } from "wouter";
import { Routes } from "../routing";

export const TrainingGuideCard: React.FC = () => {
	const [_location, navigate] = useLocation();
	const theme = useTheme();

	const hoverStyles = useStyles({
		cursor: "pointer",
		"&:hover": {
			backgroundColor: theme.colors.sandA2,
		},
	});

	return (
		<Flex
			gap="sm"
			borderRadius="md"
			padding="sm"
			className={hoverStyles}
			onClick={() => navigate(Routes.trainingGuide)}
			role="button"
			aria-label="Open training guide"
		>
			<Flex padding="xxxs">
				<Icon name="BookMarked" size="sm" color="sand12" />
			</Flex>
			<Flex column gap="xxs" grow>
				<Flex align="center" justify="space-between">
					<Text size="sm" weight="medium" color="sand12">
						Training Guide
					</Text>
					<Flex align="center" gap="xs">
						<Icon name="ChevronRight" size="sm" />
					</Flex>
				</Flex>
				<Text size="sm" color="sand11">
					Learn how to use Skyway to manage referrals effectively.
				</Text>
			</Flex>
		</Flex>
	);
};
